module.exports = __webpack_public_path__ + "img/gc.737a576b.webp";